import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { CustomFieldListItem } from './CustomFieldListItem'
import { useData } from './hooks'
import CircularProgress from '@mui/material/CircularProgress'
import { SectionTitle } from '../FormContents/styled'

type Props = {
  entityType: ENTITY_TYPES
}

export function CustomFieldList(props: Props) {
  const { customSettings, customFieldsLoading, requiredCustomFields } = useData(
    { ...props },
  )

  return (
    <>
      {customFieldsLoading ? (
        <CircularProgress />
      ) : (
        <>
          {requiredCustomFields && requiredCustomFields.length > 0 && (
            <>
              <SectionTitle>Required Custom Fields</SectionTitle>
              {requiredCustomFields.map((field) => (
                <CustomFieldListItem
                  key={field.id}
                  field={field}
                  hideOptional={false}
                  customSettings={customSettings}
                />
              ))}
            </>
          )}
        </>
      )}
    </>
  )
}
